import React, {Component} from "react";
import PropTypes from "prop-types";
import Dropdown, {DropdownContent, DropdownTrigger} from "react-simple-dropdown";

import emojiIcon from "./emoji-icon.jpg";
import EmojiDropdownContent from "./EmojiDropdownContent";

export default class EmojiDropdown extends Component {
  showNativeEmoji() {
    const platform = navigator.platform.toLocaleLowerCase();

    if (!platform) {
      return false;
    }

    return (
      platform.indexOf("mac") > -1 ||
      platform.indexOf("iphone") > -1 ||
      platform.indexOf("ipad") > -1 ||
      platform.indexOf("android") > -1 ||
      platform.indexOf("ipod") > -1
    );
  }

  render() {
    return (
      <Dropdown>
        <DropdownTrigger>
          <button className="btn btn-editor btn-emoji">
            <img src={emojiIcon} alt="" />
          </button>
        </DropdownTrigger>
        <DropdownContent>
          <EmojiDropdownContent onEmojiSelect={this.props.onEmojiSelect} />
        </DropdownContent>
      </Dropdown>
    );
  }
}

EmojiDropdown.propTypes = {
  onEmojiSelect: PropTypes.func
};
